import styled, { keyframes } from 'styled-components'
import colors from '@settings/styleSettings'

export const FaceRecognitionContainer = styled.div`
    padding: 40px;
`

export const ArrowBackContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
`
export const ArrowBackTextContainer = styled.div`
   h1{
         margin-bottom: 0;
   }

    p{
        margin-top: 5px;
        opacity: 0.5;
    }

`

export const FaceRecognitionContent = styled.div`
    width: 100%;
    border-radius: 12px;
    background-color: white;
`
export const FaceRecognitionContentHeader = styled.div`
    background-color: ${colors.primary};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 20px;
    display: flex;
    justify-content: center ;
    
`

export const FaceRecognitionContentBody = styled.div`
    background-color: ${colors.strongGray};

`
export const InputContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 30%;
   
`
export const SearchIcon = styled.div`
    cursor: pointer;
    color: white;
    font-size: 30px;
    padding-left: 19.4px;
`

export const TableContainer = styled.div`
  width: 100%;
  height: 400px;
  overflow-x: auto;
  overflow-y: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
`

export const Thead = styled.thead`

  border-bottom: 1px solid #ddd;
  height: 50px;
`

export const Th = styled.th`
  &:first-child {
    padding: 0 25px;
  }
  text-align: left;
  color: ${colors.strongGray};
  font-size: 14px;
  width: 16.66%;

  
`

const flyIn = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

export const Tr = styled.tr`
  &:last-child td {
    border-bottom: none;
  }
`

export const Td = styled.td`

  animation: ${flyIn} 0.5s;
  animation-delay: ${(props) => props.animationKey * 0.2}s;

  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  height: 50px;
`

export const NameCell = styled.div`
  display: flex;
  align-items: center;

  p{
    margin: 0;
  }
    img {
    cursor: pointer;
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }
`

export const ProfileImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background-color: green;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin-left: 20px;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
  flex-direction: row;
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  align-items: center;

   span{
    color: ${colors.strongGray};
  }
`
export const PaginationButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

 
`
export const PaginationButton = styled.div`
  background-color: transparent;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: ${colors.strongGray};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  font-size: 20px;
  border-radius: 50px;
  border: 1px solid ${colors.strongGray};
  &:hover {
    background-color: ${colors.softGray};
  }  
`
export const PaginationButtonActive = styled.button`
  background-color: ${(props) => (props.active ? colors.primary : 'transparent')};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: ${(props) => (props.active ? 'white' : 'black')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;

  &:hover {
    background-color: ${colors.softGray};
  }
`

export const Select = styled.select`
  padding: 10px 15px;
  border-radius: 12px;
  border: 1px solid ${colors.primary};
  background-color: white;

  option {
    &:hover {
      background-color: green;
      color: white;
    }
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
`
